import type { NotificationInboxItem, NotificationScope, NotificationTimelineEvent } from '../../services/tenantApi';

export function notificationEventHeading(eventType: string): string {
  if (eventType === 'NotificationReplayReceived') return 'Notification Replay Received';
  return eventType.replace(/[_-]+/g, ' ').replace(/([a-z0-9])([A-Z])/g, '$1 $2').trim() || 'Event';
}

export function notificationEventDescription(event: NotificationTimelineEvent): string {
  let errorMessage = '';
  try {
    const details = JSON.parse(event.rawDetails);
    if (typeof details?.errorMessage === 'string') errorMessage = details.errorMessage;
  } catch {}
  return [event.workflowName, event.stepOrder != null ? `Step ${event.stepOrder}` : '', event.status, errorMessage]
    .filter(Boolean).join(' - ');
}

export function supportsNotificationDetail(item: NotificationInboxItem): boolean {
  return item.sourceType?.toLowerCase() === 'inbound';
}

const terminalStatuses = new Set(['closed', 'resolved', 'cleared', 'cancelled', 'canceled']);

export function filterStandaloneNotifications(
  items: NotificationInboxItem[],
  search = '',
  unreadOnly = false,
  status = 'all',
  severity = 'all',
  service = 'all',
): NotificationInboxItem[] {
  const query = search.trim().toLowerCase();
  return items.filter((item) => item.sourceType?.toLowerCase() === 'inbound'
    && (!unreadOnly || item.isUnread)
    && (status === 'all' || (status === 'open' ? !terminalStatuses.has((item.status || '').toLowerCase())
      : (item.status || '').toLowerCase() === status.toLowerCase()))
    && (severity === 'all' || (item.severity || '').toLowerCase() === severity.toLowerCase())
    && (service === 'all' || (item.service || '').toLowerCase() === service.toLowerCase())
    && (!query || [item.title, item.subtitle, item.service, item.severity, item.status]
      .some((value) => value?.toLowerCase().includes(query))));
}

export async function clearVisibleStandaloneNotifications(
  visible: NotificationInboxItem[],
  clear: (notificationId: string, scope: NotificationScope) => Promise<void>,
): Promise<void> {
  const entries = filterStandaloneNotifications(visible);
  const results = await Promise.allSettled(entries.map((item) => clear(item.notificationId, item.scope)));
  const failed = results.filter((result) => result.status === 'rejected').length;
  if (failed) throw new Error(`Failed to clear ${failed} notification${failed === 1 ? '' : 's'}. Please retry.`);
}